import {Controller} from "@hotwired/stimulus"
import {formValidation, plugins} from "../../../../vendor/javascript/@form-validation/esm/bundle/popular"
import * as Bootstrap5 from "../../../../vendor/javascript/@form-validation/esm/plugin-bootstrap5/index.js"

export default class extends Controller {
    connect() {
        // console.log('TestimonialController connected');
        this.initializeValidation();
    }

    initializeValidation() {
        const form = document.getElementById('frm-testimonial');
        if (!form) {
            console.error('Form element not found');
            return;
        }

        // Save the validation instance to this.validation
        this.validation = formValidation(form, {
            fields: {
                'store_testimonial[order_id]': {
                    validators: {
                        notEmpty: {
                            message: 'Order number is required'
                        },
                        digits: {
                            message: 'Invalid order number'
                        },
                        stringLength: {
                            min: 5,
                            max: 5,
                            message: 'Invalid order number'
                        }
                    }
                },
                'store_testimonial[content]': {
                    validators: {
                        notEmpty: {
                            message: 'Please share your feedback'
                        },
                        stringLength: {
                            min: 10,
                            max: 1000,
                            message: 'Your review must be between 10 and 1000 characters'
                        }
                    }
                }
            },
            plugins: {
                trigger: new plugins.Trigger({
                    event: 'blur'
                }),
                submitButton: new plugins.SubmitButton(),
                bootstrap5: new Bootstrap5.Bootstrap5({
                    rowSelector: '.mb-3',
                    eleInvalidClass: 'is-invalid',
                    eleValidClass: 'is-valid',
                }),
                aria: new plugins.Aria(),
            }
        }).on('core.form.valid', function (e) {
            form.submit();
        })
            .on('core.form.invalid', function (e) {
                // console.log('Form is invalid!');
            });
    }

    disconnect() {
        // Clean up FormValidation instance when the controller is disconnected
        if (this.validation) {
            this.validation.destroy();
        }
    }
}